// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"125":"34875da9","654":"812bf3cb"}[chunkId] + ".chunk.css";
};